var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('app-schedule-cal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }